import Footer from '@/components/_rebrand/Footer';
import Header from '@/components/_rebrand/Header';
import RebrandDemoModal from '@/components/_rebrand/Modals/DemoModal';
import RebrandTrialModal from '@/components/_rebrand/Modals/TrialModal';
import DemoModal from '@/components/modals/DemoModal';
import GetStartedModal from '@/components/modals/GetStartedModal/Modal';
import TrialModal from '@/components/modals/TrialModal';
import FOOTER_PROPS from '@/constants/global-props/footer';
import HEADER_PROPS from '@/constants/global-props/header';
import { GlobalContext } from '@/context';
import '@/styles/_rebrand/main.css';
import React, { FC, PropsWithChildren, useContext } from 'react';
import styled from 'styled-components';
const TemplateWrapper = styled.section`
  position: relative;
`;

import cn from 'classnames';

interface MasterTemplateProps extends PropsWithChildren {
  invert?: boolean;
  hideTopPattern?: boolean;
  showAnnouncement?: boolean;
  navigation?: React.ReactNode;
  footer?: React.ReactNode;
  globalIncludes?: React.ReactNode;
  className?: string;
}

const MasterTemplate: FC<MasterTemplateProps> = ({ children, ...props }) => {
  const { showAnnouncement, invert, hideTopPattern, navigation, footer, globalIncludes, className } = props;
  const { showGetStartedModal, showTrialModal, showDemoModal, forceInvertedNav } = useContext(GlobalContext);
  const hideTopPatternCheck = (hideTopPattern === false ? false : true);

  return (
    <TemplateWrapper>
      {/* {showAnnouncement && <GlobalAnnouncementBanner />} */}

      {/* Navigation - invert prop is for static page-level inversion, forceInvertedNav is for dynamic component-level inversion (e.g., FlexPageHero) */}
      {navigation ?? <Header {...HEADER_PROPS} invert={invert || forceInvertedNav} />}

      {/* Page content */}
      <div className={cn(className, 'relative -mt-[95px]')}>{children}</div>

      {/* Footer */}
      {footer ?? <Footer {...FOOTER_PROPS} hideTopPattern={hideTopPatternCheck} />}

      {/* Modals */}
      {showGetStartedModal && <GetStartedModal />}
      <TrialModal />
      {showDemoModal && <DemoModal />}

      {/* Rebrand Modals - need to include these separately due to different wiring in rebrand header */}
      <RebrandDemoModal />
      <RebrandTrialModal />

      {/* Global Includes */}
      {globalIncludes ?? null}
    </TemplateWrapper>
  );
};

MasterTemplate.defaultProps = {
  showAnnouncement: true,
};

export default MasterTemplate;
